<template>
  <button
    class="data-details__action"
    :class="{ disabled: isReviewAdded }"
    :disabled="isReviewAdded"
    type="button"
    @click="addReview"
  >
    <span>
      <TheReviewIcon v-if="!isReviewAdded" />
      <TheConfirmedIcon v-else />
    </span>
    <span>{{ label }}</span>
  </button>
</template>

<script>
import TheReviewIcon from '@/components/icons/TheReviewIcon.vue';
import TheConfirmedIcon from '@/components/icons/TheConfirmedIcon.vue';
import CtaClickedGaEvent from '@/helpers/ga/events/CtaClickedGaEvent';
import { getContentTypeFromEntityType } from '@/helpers/ga/params/contentTypeParam';
import { sendGaEvent } from '@/helpers/ga/gaSend';

export default {
  name: 'AddReviewAction',
  components: { TheConfirmedIcon, TheReviewIcon },
  props: {
    event: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      label: 'Add Review',
      isReviewAdded: false,
    };
  },
  methods: {
    addReview() {
      this.$emit('click');

      if (!this.isReviewAdded) {
        const gaEvent = new CtaClickedGaEvent(this.label)
          .addContentType(getContentTypeFromEntityType(this.event.__typename))
          .addContentId(this.event.id)
          .addContentName(this.event.title);

        sendGaEvent(gaEvent);

        this.$router.push(this.$route.path.replace(/\/+$/, '') + '/reviews');
      }
    },
  },
};
</script>
